<template>
  <div style="clear: both">
    <template v-if="readonly">
      <v-col class="px-0">
        <template v-for="question in questions">
          <template v-if="question.type === QTypeMultiSelect">
            <v-textarea
              :model-value="question.answers && question.answers.length > 0 ? getAnswers(question.answers) : null"
              :label="question.label"
              readonly
              variant="underlined"
              :key="`label${question.id}`"
              auto-grow
              rows="1"
              dense
              density="comfortable"
              persistent-placeholder
              class="v-input--is-focused"
            >
            </v-textarea>
          </template>
          <template v-else>
            <v-text-field
              :model-value="question.answers && question.answers.length > 0 ? getAnswers(question.answers) : null"
              :label="question.label"
              variant="underlined"
              readonly
              :key="`label${question.id}`"
              dense
              density="comfortable"
              persistent-placeholder
              class="v-input--is-focused"
            ></v-text-field
          ></template>
        </template>
      </v-col>
    </template>

    <template v-if="!readonly">
      <v-col class="px-0">
        <template v-for="question in answeredQuestions[0]">
          <template v-if="question.type === QTypeDropDown">
            <v-autocomplete
              :model-value="question.answers && question.answers.length > 0 ? question.answers[0] : null"
              variant="underlined"
              :items="question.values"
              :label="question.label"
              :menu-props="{ auto: true, maxHeight: 500 }"
              :filter="customFilter"
              item-title="label"
              item-value="valueId"
              return-object
              :hint="question.hint"
              @update:model-value="valueChanged($event, question)"
              :key="question.id"
              :name="question.id"
              :error-messages="question.answers && question.answers.length > 0 ? null : ' '"
              :rules="[(v) => !!v || ' ']"
              dense
              density="comfortable"
              :placeholder="`${question.label} ${$t('Is_Required')}`"
              persistent-placeholder
              class="v-input--is-focused"
            ></v-autocomplete>
          </template>
          <template v-if="question.type === QTypeMultiSelect">
            <v-autocomplete
              :model-value="question.answers"
              variant="underlined"
              :items="question.values"
              :label="question.label"
              :menu-props="{ maxHeight: 500 }"
              chips
              closable-chips
              :filter="customFilter"
              item-title="label"
              item-value="valueId"
              multiple
              eager
              return-object
              :hint="question.hint"
              persistent-hint
              @update:model-value="valueSelected($event, question.id)"
              :key="question.id"
              :name="question.id"
              :rules="[(v) => !!v || ' ', (v) => v.length > 0 || ' ']"
              dense
              density="comfortable"
              :placeholder="`${question.label} ${$t('Is_Required')}`"
              persistent-placeholder
              class="v-input--is-focused"
            ></v-autocomplete>
          </template>
          <template v-if="question.type === QTypeText && question.required">
            <v-text-field
              :model-value="question.answers && question.answers.length > 0 ? getAnswers(question.answers) : null"
              variant="underlined"
              :label="question.label"
              :key="question.id"
              @update:model-value="textValueEntered($event, question.id)"
              clearable
              :hint="question.hint"
              :name="question.id"
              :rules="[(v) => !!v || ' ']"
              dense
              density="comfortable"
              :placeholder="`${question.label} ${$t('Is_Required')}`"
              persistent-placeholder
              class="v-input--is-focused"
            ></v-text-field>
          </template>
          <template v-if="question.type === QTypeText && !question.required">
            <v-text-field
              :model-value="question.answers && question.answers.length > 0 ? getAnswers(question.answers) : null"
              variant="underlined"
              :label="question.label"
              :key="question.id"
              @update:model-value="textValueEntered($event, question.id)"
              clearable
              :hint="question.hint"
              :name="question.id"
              dense
              density="comfortable"
              persistent-placeholder
              class="v-input--is-focused"
            ></v-text-field>
          </template>
        </template>
      </v-col>
    </template>

    <toaster ref="toaster"></toaster>
  </div>
</template>

<script>
import { FormStatus, Roles } from '@/common'
import { AnswerTypes } from '@/common/types'
import Toaster from '@/components/Toaster'
export default {
  emits: ['answered', 'dirty'],
  name: 'TreeQuestions',
  data() {
    return {
      answeredQuestions: [],
      valid: false,
      dirty: false,
      removeRootParent: null
    }
  },
  props: {
    questions: {
      type: Array
    },
    question: {
      type: Object
    },
    type: {
      type: String
    },
    roles: {
      type: Array,
      default: null
    },
    forceReadOnly: {
      type: Boolean,
      default: false
    },
    previousFormStatus: {
      type: Object
    },
    moc: {
      type: Object
    }
  },
  components: {
    Toaster
  },
  computed: {
    QTypeDropDown: function () {
      return AnswerTypes.DROPDOWN
    },
    QTypeMultiSelect: function () {
      return AnswerTypes.MULTISELECT
    },
    QTypeText: function () {
      return AnswerTypes.TEXT
    },
    readonly: function () {
      if (this.forceReadOnly) {
        return true
      }
      switch (this.moc.status.value) {
        case FormStatus.properties[FormStatus.NEW].value:
        case FormStatus.properties[FormStatus.DRAFT].value:
        case FormStatus.properties[FormStatus.SENTBACKFORCORRECTIONS].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          break
        case FormStatus.properties[FormStatus.BEINGREVISED].value:
          if (this.moc.history.some((e) => e.status.value === FormStatus.properties[FormStatus.AVAILABLETOIMPLEMENT].value)) {
            return true
          }

          if (
            (this.previousFormStatus.value === FormStatus.properties[FormStatus.AVAILABLEFORDECISION].value ||
              this.previousFormStatus.value === FormStatus.properties[FormStatus.PENDINGOWNERDECISION].value) &&
            (this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
              this.roles.includes(Roles.properties[Roles.COINITIATOR].value) ||
              this.roles.includes(Roles.properties[Roles.OWNER].value))
          ) {
            return false
          }
          break
        default:
          return true
      }
      return true
    }
  },
  methods: {
    answersContainAnswer: function (array, valueId) {
      var exists = array.filter((a) => {
        return a.valueId === valueId
      })
      if (exists.length === 0) {
        return false
      }
      return true
    },
    answersOnly: function (allQuestions) {
      let answers = allQuestions.map((aq) => ({
        id: aq.id,
        label: aq.label,
        parent: aq.id,
        answers: [...aq.answers.map((aqa) => ({ id: aqa.id, valueId: aqa.valueId, label: aqa.label }))]
      }))
      return answers
    },
    getQuestions: function (ques) {
      let result = []

      if (ques != null) {
        ques.forEach((question) => {
          let values = []
          if (question.enabled) {
            if (question.values != null) {
              question.values.forEach((value) => {
                if (value.enabled) {
                  values.push({
                    ...value,
                    valueId: value.id
                  })
                }
              })
            }

            let currentAnswers = []
            if (question.answers) {
              question.answers.forEach((answer) => {
                currentAnswers.push(answer)
              })
            }

            result.push({
              id: question.id,
              type: question.type,
              label: question.label,
              parent: question.parent,
              order: question.order,
              answers: currentAnswers,
              values: values.sort((a, b) => a.order - b.order),
              hint: question.hint,
              enabled: true,
              required: question.required
            })
          }
        })
        return result
      }
    },
    getAnswer(answer) {
      return answer.label.trim().replace(/,$/, '')
    },
    getAnswers(answers) {
      let results = ''
      answers.forEach((a) => {
        if (a.label != null) results += a.label.concat(', ')
      })
      return results.trim().replace(/,$/, '')
    },
    getAnswersAsArray(answers) {
      let temp = [...answers]
      return temp
    },
    textValueEntered(v, id) {
      this.dirty = true
      // first get the index of the element that contains the parent then tack on the order
      let pos = this.answeredQuestions[0].findIndex((q) => {
        return q.id === id
      })
      // wipe the array
      this.answeredQuestions[0][pos].answers = []
      // add the value
      this.answeredQuestions[0][pos].answers.push({
        value: v,
        label: v
      })

      this.$emit('answered', this.answersOnly(this.answeredQuestions[0]))

      if (this.answeredQuestions[0][pos].required !== false) {
        //this.dirty = false
        this.$emit('dirty', this.dirty)
      }
    },
    removeChildren: function (questionArray, id) {
      if (questionArray.some((q) => q.parent === id)) {
        let children = questionArray.filter((q) => q.parent === id)

        children.forEach((c) => {
          questionArray = this.removeChildren(questionArray, c.id)
        })
      }

      if (this.removeRootParent !== id) {
        let index = questionArray.findIndex((o) => o.id === id)
        questionArray[index].answers = []
        questionArray = questionArray.filter((x) => {
          return x.id !== id
        })
      }

      return questionArray
    },
    valueChanged(e, q) {
      this.valueSelected(e, q.id)
    },
    async valueSelected(v, pId) {
      this.dirty = true
      if (v !== undefined) {
        if (v.questions != null) {
          let apos = this.answeredQuestions[0].findIndex((i) => i.id === v.parent)
          let previousValueId =
            (this.answeredQuestions[0][apos].answers || []).length > 0 ? this.answeredQuestions[0][apos].answers[0].valueId : null
          if (v.valueId === previousValueId) {
            return
          }
          // first if the answer changed and different questions were spawned, clean up
          this.removeRootParent = v.parent
          this.answeredQuestions[0] = this.removeChildren(this.answeredQuestions[0], v.parent)
          this.$forceUpdate()
          let q = this.getQuestions(v.questions)
          // this is a hack to set the parent id for the current value
          if ((q || []).length > 0) {
            q[0].parent = pId
          }

          q.sort((a, b) => {
            return b.order - a.order
          }).forEach((question) => {
            // first get the index of the element that contains the parent then tack on the order
            let pos = this.answeredQuestions[0]
              .map((question) => {
                return question.id
              })
              .indexOf(question.parent)

            question.answers = []

            this.answeredQuestions[0][pos].answers.push({
              valueId: v.id,
              label: v.label
            })

            // add to answeredQuestions to add component to view
            this.answeredQuestions[0].splice(pos + 1, 0, question)

            // check to make sure there is no dups
            let found = false
            if (this.answeredQuestions[0][pos].answers.some((item) => item.valueId === v.id)) {
              found = true
            }
            // if answer was not found, add it
            if (!found) {
              this.answeredQuestions[0][pos].answers.push({
                valueId: v.id,
                label: v.label
              })
            }
            if (question.values.length === 1) {
              this.valueSelected(question.values[0], question.id)

              if (!this.answersContainAnswer(this.answeredQuestions[0][pos + 1].answers, question.values[0].id)) {
                this.answeredQuestions[0][pos + 1].answers.push({
                  valueId: question.values[0].id,
                  label: question.values[0].label
                })
              }
            }
          })

          // we are here because we have a select where the value does not spawn anything
          // we need to add the answer (v)
          let deadEndPos = this.answeredQuestions[0].findIndex((q) => {
            return q.id === pId
          })

          // wipe answers, just in case...
          this.answeredQuestions[0][deadEndPos].answers = []
          this.answeredQuestions[0][deadEndPos].answers.push({
            valueId: v.id,
            label: v.label
          })
        } else {
          // multiselect (at the time of writing this, multiselects could not spawn questions)
          if (v.length > 0) {
            let firstTimeThough = true

            // lets get all the items from v that contain a parent node
            let selectedValues = v.filter((pi) => {
              return pi.parent != null
            })

            selectedValues.forEach((selectedAnswer) => {
              if (selectedAnswer.parent) {
                let pos = this.answeredQuestions[0]
                  .map((question) => {
                    return question.id
                  })
                  .indexOf(selectedAnswer.parent)

                // first time through, clean up the array as all values are coming in
                if (firstTimeThough) {
                  this.answeredQuestions[0][pos].answers = []
                  firstTimeThough = false
                }
                // check to make sure there is no dups
                let found = false

                if (this.answeredQuestions[0][pos].answers.some((item) => item.valueId === selectedAnswer.id)) {
                  found = true
                }
                // if answer was not found, add it
                if (!found) {
                  //this.answeredQuestions[0][pos].parent = pId // I think we need the questions parent, not the answers parent, yes, yes we do.
                  this.answeredQuestions[0][pos].answers.push({
                    valueId: selectedAnswer.id,
                    label: selectedAnswer.label,
                    ...selectedAnswer
                  })
                }
              }
            })
          } else {
            // The user has cleared all the selected values of the multiselect
            // we need to wipe the remaining answer
            let pos = this.answeredQuestions[0]
              .map((question) => {
                return question.id
              })
              .indexOf(pId)

            if (pos >= 0) {
              this.answeredQuestions[0][pos].answers = []
            }
          }
        }

        await this.$nextTick()
        this.$emit('answered', this.answersOnly(this.answeredQuestions[0]))
        this.$emit('dirty', this.dirty)
      }
    },
    customFilter(item, queryText, itemText) {
      const textOne = itemText.toLowerCase()
      const searchText = queryText.toLowerCase()

      return textOne.toLowerCase().indexOf(searchText) === 0
    }
  },
  async mounted() {
    const x = this.getQuestions(this.questions)
    this.answeredQuestions.push(x)

    if (this.answeredQuestions[0].length > 0) {
      this.questions.forEach((q) => {
        if (q.values.length === 1 && this.moc.status === FormStatus.properties[FormStatus.NEW].value) {
          const answeredQuestionIndex = this.answeredQuestions[0].findIndex((x) => x.id === q.id)
          let answeredQuestion = this.answeredQuestions[0][answeredQuestionIndex]
          answeredQuestion.answers.push({
            ...answeredQuestion.values[0],
            valueId: answeredQuestion.values[0].id
          })
          const isMultiselect = answeredQuestion.type === 'multiselect'
          this.valueSelected(isMultiselect ? answeredQuestion.values : answeredQuestion.values[0], answeredQuestion.id)
          this.dirty = true
        }
      })

      await this.$nextTick()
      this.$emit('answered', this.answersOnly(this.answeredQuestions[0]))
    }
  }
}
</script>

<style scoped></style>
